import isLocal from '../common/isLocal.js'

const packageToFolder = {
  tpaIntegration: 'Santa-Integration-Protractor',
  wixCodeIntegration: 'js-wixcode-integration',
  platformIntegrationEditor: 'js-platform-integration',
  tpaIntegrationEditor: 'Santa-Editor-Integration-Protractor'}

export default function getIntegrationPath(packageName, baseArtifact) {
  const integrationBasePath = isLocal(baseArtifact) ? '//localhost:4578' :
    `//s3.amazonaws.com/integration-tests-statics/${packageToFolder[packageName]}/SNAPSHOT/runners`

  return `${integrationBasePath}/${packageName}/src/main`
}


// WEBPACK FOOTER //
// ./~/santa-main-r/src/lib/common/getIntegrationPath.js